import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ActionButtons = ({ 
  selectedOccupation, 
  selectedSeniority, 
  user, 
  onSaveForLater,
  onStartAssessment,
  className = '' 
}) => {
  const navigate = useNavigate();
  const canProceed = selectedOccupation && selectedSeniority;
  const isAuthenticated = !!user;

  // Handle sign in navigation
  const handleSignIn = () => {
    navigate('/authentication');
  };

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Primary Action */}
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          variant="default"
          size="lg"
          disabled={!canProceed}
          onClick={onStartAssessment}
          iconName="ArrowRight"
          iconPosition="right"
          className="sm:min-w-48"
        >
          Start Assessment
        </Button>

        {isAuthenticated && (
          <Button
            variant="outline"
            size="lg"
            disabled={!canProceed}
            onClick={onSaveForLater}
            iconName="Save"
            iconPosition="left"
            className="sm:min-w-48"
          >
            Save for Later
          </Button>
        )}
      </div>

      {/* Authentication Prompt for Guests */}
      {!isAuthenticated && (
        <div className="text-center">
          <div className="bg-muted/50 rounded-lg p-4 max-w-md mx-auto">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Icon name="Info" size={16} className="text-primary" />
              <span className="text-sm font-medium text-foreground">Save Your Progress</span>
            </div>
            <p className="text-sm text-muted-foreground mb-3">
              Create an account to save your assessment progress and access your personalized career plan anytime.
            </p>
            <div className="flex flex-col sm:flex-row gap-2 justify-center">
              <Button
                variant="default"
                size="sm"
                iconName="LogIn"
                iconPosition="left"
                onClick={handleSignIn}
              >
                Sign In
              </Button>
              <Button
                variant="ghost"
                size="sm"
                iconName="UserPlus"
                iconPosition="left"
                asChild
              >
                <Link to="/authentication?tab=register">Create Free Account</Link>
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Help Text */}
      <div className="text-center space-y-2">
        {!canProceed && (
          <p className="text-sm text-muted-foreground">
            Please select both your occupation and seniority level to continue
          </p>
        )}
        
        <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Clock" size={12} />
            <span>10-20 minutes</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Shield" size={12} />
            <span>Secure & Private</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Zap" size={12} />
            <span>AI-Powered</span>
          </div>
        </div>
      </div>

      {/* Back Navigation */}
      <div className="text-center pt-4 border-t border-border">
        <Button
          variant="ghost"
          size="sm"
          iconName="ArrowLeft"
          iconPosition="left"
          asChild
        >
          <Link to="/progress-dashboard">Back to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;